/* ============ Vitrine — theme.js ============ */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : '';
    return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2 }) + (fmt ? ' ' + fmt : '');
  };

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var total = drawer.querySelector('[data-cart-total]');

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    if (!cart.items.length) {
      body.innerHTML = '<p class="drawer__empty">Your bag is empty.</p>';
      foot.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[^.]*)$/, '_200x$1') : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      return '<div class="li">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div class="li__ph"></div>') +
        '<div class="li__d">' +
          '<b>' + it.product_title + '</b>' +
          (variant ? '<span>' + variant + '</span><br>' : '') +
          '<span>Qty ' + it.quantity + ' · ' + money(it.final_line_price) + '</span>' +
          '<button class="li__x" data-remove="' + it.key + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    total.textContent = money(cart.total_price);
    foot.hidden = false;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function addToCart(id, qty, btn) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to bag.'); });
        return r.json();
      })
      .then(function () { return fetchCart(); })
      .then(function () { openDrawer(); })
      .catch(function (e) { alert(e.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }

  document.addEventListener('click', function (e) {
    var close = e.target.closest('[data-drawer-close]');
    if (close) { closeDrawer(); return; }

    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); fetchCart().then(openDrawer); return; }

    var rm = e.target.closest('[data-remove]');
    if (rm) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: rm.dataset.remove, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(renderCart);
      return;
    }

    var qa = e.target.closest('[data-quick-add]');
    if (qa) { e.preventDefault(); addToCart(qa.dataset.quickAdd, 1, qa); return; }

    var burger = e.target.closest('[data-menu-toggle]');
    if (burger) {
      var m = document.getElementById('MobileNav');
      if (m) m.classList.toggle('is-open');
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Product form ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    var qty = form.querySelector('[name="quantity"]');
    addToCart(id, qty ? qty.value : 1, form.querySelector('[type="submit"]'));
  });

  /* ---------- Quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-qty]');
    if (!s) return;
    var input = s.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = s.dataset.qty === 'up' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var variants;
    try { variants = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (err) { return; }

    function update() {
      var chosen = Array.prototype.map.call(
        root.querySelectorAll('input[type=radio]:checked'),
        function (i) { return i.value; }
      );
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });

      var idInput = root.querySelector('[name="id"]');
      var btn = root.querySelector('[data-atc]');
      var priceEl = root.querySelector('[data-price]');

      if (!match) {
        btn.disabled = true;
        btn.textContent = 'Unavailable';
        return;
      }

      idInput.value = match.id;
      btn.disabled = !match.available;
      btn.textContent = match.available ? 'Add to cart' : 'Sold out';

      if (priceEl) {
        var html = '<span class="' + (match.compare_at_price > match.price ? 'on-sale' : '') + '">' + money(match.price) + '</span>';
        if (match.compare_at_price > match.price) html += '<s>' + money(match.compare_at_price) + '</s>';
        priceEl.innerHTML = html;
      }

      if (match.featured_media) {
        var thumb = root.closest('.pdp') && root.closest('.pdp').querySelector('[data-media="' + match.featured_media.id + '"]');
        if (thumb) thumb.click();
      }

      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    root.querySelectorAll('input[type=radio]').forEach(function (i) {
      i.addEventListener('change', update);
    });
  });

  /* ---------- Gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    gal.querySelectorAll('[data-media]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.dataset.full;
        main.srcset = '';
        gal.querySelectorAll('[data-media]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- Sticky ATC ---------- */
  var satc = document.querySelector('[data-satc]');
  var buybox = document.querySelector('[data-buybox]');
  if (satc && buybox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      satc.classList.toggle('is-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(buybox);
  }

  /* ---------- Marquee duplication (seamless loop) ---------- */
  document.querySelectorAll('[data-loop]').forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });

  /* ---------- Init ---------- */
  if (drawer) fetchCart();
})();

/* ============ Vitrine — extra sections ============ */
(function () {
  'use strict';

  /* ---------- Before / after ---------- */
  document.querySelectorAll('[data-ba]').forEach(function (ba) {
    var range = ba.querySelector('[data-ba-range]');
    if (!range) return;
    var set = function (v) { ba.style.setProperty('--start', v + '%'); };
    range.addEventListener('input', function () { set(range.value); });
    set(range.value);
  });

  /* ---------- Slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (ss) {
    var track = ss.querySelector('[data-ss-track]');
    var slides = track ? track.children.length : 0;
    if (!track || slides < 2) return;

    var i = 0, timer = null;
    var dots = ss.querySelectorAll('[data-ss-dot]');

    function go(n) {
      i = (n + slides) % slides;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function play() {
      if (ss.dataset.autoplay !== 'true') return;
      stop();
      timer = setInterval(function () { go(i + 1); }, parseInt(ss.dataset.interval, 10) || 6000);
    }
    function stop() { if (timer) clearInterval(timer); }

    var prev = ss.querySelector('[data-ss-prev]');
    var next = ss.querySelector('[data-ss-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.dataset.ssDot, 10)); play(); });
    });

    ss.addEventListener('mouseenter', stop);
    ss.addEventListener('mouseleave', play);

    var x0 = null;
    ss.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    ss.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
      play();
    });

    go(0);
    play();
  });

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-countdown]').forEach(function (cd) {
    var end = new Date(cd.dataset.countdown.replace(' ', 'T')).getTime();
    if (isNaN(end)) return;

    var d = cd.querySelector('[data-cd-d]'), h = cd.querySelector('[data-cd-h]');
    var m = cd.querySelector('[data-cd-m]'), s = cd.querySelector('[data-cd-s]');
    var pad = function (n) { return String(n).padStart(2, '0'); };

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        cd.classList.add('is-done');
        if (cd.dataset.expiredText) {
          var p = document.createElement('p');
          p.className = 'lead';
          p.textContent = cd.dataset.expiredText;
          cd.insertAdjacentElement('afterend', p);
        }
        clearInterval(iv);
        return;
      }
      d.textContent = pad(Math.floor(left / 86400000));
      h.textContent = pad(Math.floor(left / 3600000) % 24);
      m.textContent = pad(Math.floor(left / 60000) % 60);
      s.textContent = pad(Math.floor(left / 1000) % 60);
    }
    var iv = setInterval(tick, 1000);
    tick();
  });
})();
